import { render } from "./MotivoRef.vue?vue&type=template&id=7a1b8f24&scoped=true"
import script from "./MotivoRef.vue?vue&type=script&lang=js"
export * from "./MotivoRef.vue?vue&type=script&lang=js"

import "@/assets/css/listaFiltrada.css?vue&type=style&index=0&id=7a1b8f24&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a1b8f24"]])

export default __exports__